<template>
  <div class="rr-timeline">
    <div class="rr-timeline__line">
      <div ref="from" class="rr-timeline__time rr-timeline__time_from">
        <div class="rr-timeline__time-val">{{ from }}</div>
      </div>
      <div ref="to" class="rr-timeline__time rr-timeline__time_to">
        <div class="rr-timeline__time-val">{{ to }}</div>
      </div>
    </div>
    <div class="rr-timeline__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Timeline',
  designVersion: '1.0.0',
  props: {
    from: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Timeline";
</style>
